var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"disabled":"","dense":"","label":_vm.$t('dangerousGoods.dangerousGoodsList.form.storageLocation')},model:{value:(_vm.storageLocationName),callback:function ($$v) {_vm.storageLocationName=$$v},expression:"storageLocationName"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }